import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { ServiceContentService } from './api/serviceContent.service';
import { ServicePartnerService } from './api/servicePartner.service';
import { ServicePlanService } from './api/servicePlan.service';
import { VasServiceService } from './api/vasService.service';
import { VasServiceNetworkService } from './api/vasServiceNetwork.service';
import { VasServiceResponseService } from './api/vasServiceResponse.service';
import { VasServiceRevenueService } from './api/vasServiceRevenue.service';
import { VasServiceRouteService } from './api/vasServiceRoute.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    ServiceContentService,
    ServicePartnerService,
    ServicePlanService,
    VasServiceService,
    VasServiceNetworkService,
    VasServiceResponseService,
    VasServiceRevenueService,
    VasServiceRouteService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
